module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-11"
    }
  }, [_c('h2', {
    staticClass: "chap1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap2"
  }, [_vm._v("HISTORY OF THE CENSUS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("F")]), _vm._v("amily historians have been using census records for over forty years. Often referred to as ‘genealogy’s most useful resource’, the census became central to popular family history when searchable records were placed online in 2002. Before this, genealogists and other researchers had to search painstakingly through reels of microfilm to find their ancestors. Now transcriptions and images of the 1841–1911 censuses can be explored from the comfort of a home computer or at a local library. However, the census was never intended for the use of family historians. Some censuses have been destroyed deliberately over the years, while others have been damaged in war or through the damp and decay of poor storage. Where censuses have survived, it is often due to a chance event or the intervention of an official concerned with demographic, socio-economic or political factors. Censuses, in some form, date from early history, but family historians are most concerned with those created in the nineteenth and early twentieth centuries. This book will explore these, and look at how family historians can best use them for their research.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead",
    attrs: {
      "id": "h3a1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("What is a Census?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("According to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oxford New Shorter English Dictionary")]), _vm._v(", a census is defined as:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("n.")]), _vm._v(" & "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("v.")]), _vm._v(" E17. [L, f, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("censere")]), _vm._v(" assess: cf. CENSE "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("n")]), _vm._v(".] "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("A")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("n")]), _vm._v(". † "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" A tax, a tribute; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("esp")]), _vm._v(". a poll tax. E17–M19. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist")]), _vm._v(". The registration of citizens and their property in ancient Rome, usu. for taxation purposes. M17. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" An official enumeration of the population of a country etc., or of a class of things, usu. with statistics relating to them. M18 "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("B")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("v.t.")]), _vm._v(" Conduct a census of; count, enumerate. L19.")])])]), _c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The ‘E17’ in this definition suggests that the use of the word ‘census’ in English dates only from the early seventeenth century. However, the use of the Latin term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cense")]), _vm._v(" dates from the days of the Roman Empire. Through the Bible, Britons were aware of the Roman census, although not necessarily of its full significance. Christians marking the birth of Jesus each Christmas were familiar with the words from the Gospel of St Luke (2, 1–3):")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("And it came to pass in those days, that there went out a decree from Caesar Augustus, that all the world should be taxed. (And this taxing was first made when Cyrenius was governor of Syria.) And all went to be taxed, every one into his own city.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }, [_vm._v("This census of circa "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 0"), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a1",
      "id": "A1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" was thus the alleged reason that Jesus’ mother Mary and her husband, Joseph, were travelling from Nazareth to Bethlehem, where the baby was believed to be born. At the time, citizens of the Roman Empire had to register for the census in their place of family origin. As Joseph was descended from the line of David, he had to register in Bethlehem, the town of David in Judea. Historians have questioned this, arguing that no such movement of people was required. Nevertheless, the Roman census was taken quinquennially between 550 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" and "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(" 14. Before the mid-fourth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", the statistics are regarded as unreliable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The earliest recorded census was of Mesopotamia in 3800 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" under the command of the king of Babylonia. The purpose of all the early censuses was to establish resources of both finance and human beings. The Babylonians recorded the number of pigs, among other produce in their lands, while the Romans monitored numbers of men available for taxation purposes, as well as for their extensive armies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the seventh century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")]), _vm._v(", a census was taken of the kingdoms of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dal Riata")]), _vm._v(", the Gaelic lands that now form part of Scotland and Northern Ireland. This census is contained with royal genealogies in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Senchus Fer n-Alban")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of the Men of Scotland")]), _vm._v("), and reveals how the population was divided within fiscal and military groups.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like the rulers of Babylon and of Rome, after William the Conqueror had settled in England, he wanted to establish the numbers of men and resources available to him. This resulted in a form of census known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Domesday Book")]), _vm._v(", the original of which is held at The National Archives. The assessment, begun in 1085, recorded 13,418 settlements of the counties south of the rivers Ribble and Tees. More than twenty royal commissioners acted as census enumerators in seven circuits (regions). It concentrated on the king’s property and land, providing details of the nature of the land, any buildings and the resources of the land (e.g. fish, animals, plants). A jury of local people gave the names of the landholders ("), _c('span', {
    attrs: {
      "href": "#/xhtml/024_Glossary#gloss37",
      "id": "Gloss37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("tenants")]), _vm._v("-in-chief), tenants and under-tenants to the royal commissioners. The social position of the tenants as villagers, smallholders, free men or slaves was also identified. Urban entries include records of traders.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p13.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Page from Domesday Book showing the entry for Bertram de Verdun.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not everyone was included. Only heads of households were recorded and notable absences from the book are nuns, monks and people living in castles, as well as the inhabitants of London, Winchester, Bristol, the borough of Tamworth and the lands that became Westmoreland, Cumberland, Northumberland and Durham. The book remained incomplete: work on the survey was abandoned in 1087, during the reign of William Rufus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1676, the Bishop of London, Henry Compton, initiated an ecclesiastical survey of individual parishes. The Compton census, as this is commonly known, aimed to discover an estimate of the numbers of Anglicans (Conformists), Catholic recusants (Papists), and Protestant Dissenters (Nonconformists) in England and Wales. As may be expected from this early census, results were inconsistent. The incumbent was asked:")])]), _c('div', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("1stly What number of persons are there by common Account & estimation inhabiting within each parish subject to your jurisdiction?")])]), _c('a', {
    attrs: {
      "id": "VPS-14"
    }
  }, [_c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("2dly What number of Popish Recusants or persons suspected for such Recusancy are there resident amongst the Inhabitants aforesaid?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("3dly What number of other Dissenters are there in each parish of what Sect soever which either obstinately refuse or wholly absent themselves from the Communion of the Church of England at such times as by law they are required.")])])]), _c('a', {
    attrs: {
      "id": "VPS-14"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-14"
    }
  }, [_vm._v("The total number of people in the parish was intended to include only those of 16 years and over, but this instruction was often misinterpreted. There is evidence of omissions from the census, such as the cottagers of the parish of Llandaff."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a2",
      "id": "A2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" Besides this, some Protestant Dissenters attended church as well as chapel, and were thus recorded twice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The census was administered by the deaconries and arch-deaconries. As such, where original returns survive, they may be found in individual archdeaconry records. Most exist only in the form of an eighteenthcentury manuscript held at the William Salt Library in Stafford. Anne Whiteman has edited the returns and they are now available to read in book form: Anne Whiteman (ed.) (with Mary Clapinson), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Compton Census of 1676: A Critical Edition")]), _vm._v(" (British Academy: Records of Social and Economic History, N.S. 10, 1986).")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead",
    attrs: {
      "id": "h3a2"
    }
  }, [_vm._v("How and Why Were the Nineteenth-Century Census Records Created?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From the mid-eighteenth century, the census in Western Europe and America became more of an official enumeration of the population of a country, rather than merely an exercise in resource-counting. This was influenced, in part, by the writings of the French philosopher Jean Bodin (1529/30–96). In his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Six Books of the Commonwealth")]), _vm._v(" (1576), Bodin acknowledged the usefulness of censuses for establishing military availability, colonial personnel and a domestic labour force. He also praised their ability to identify how members of the population were occupied and what property they owned, such as in the 1471 census of Provence. Bodin respected the Roman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("censor")]), _vm._v("’s role as not merely an enumerator but as the officer responsible for public morality. The census, through the medium of its censor, therefore, was responsible for maintaining the high standards of the Roman Empire and its tight control on tax abuse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bodin’s ideas influenced attitudes to the census during the period of the Enlightenment in the late seventeenth and eighteenth centuries. The Enlightenment’s focus on knowledge and understanding of everything inspired politicians across Europe to introduce censuses of their"), _c('a', {
    attrs: {
      "id": "VPS-15"
    }
  }, [_vm._v(" populations. From Sweden in 1749, to Norway and Denmark in 1769, to German states in 1776, and Austria and Spain in 1787, the rulers of Western Europe sought to fully know their citizens through the medium of the census. From this knowledge, governments could exert greater control of their populations, not just for military or economic purposes, but for social and moral ends, too. The first country to introduce a regular census was the United States in 1790. Britain soon followed, initiating her first census eleven years later in 1801."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a3",
      "id": "A3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before 1801, rulers of specific parts of Britain had conducted their own censuses, usually when planning their local militia. In a few cases, names can be found in what survives of these census records. Some local overseers created nominal lists to assist with the administration, but most only named the head of the household.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1753, Thomas Potter (1718–59), a Member of Parliament, had tried to introduce an annual census to take place from 1754, but his bill failed to pass in the House of Commons. This failure was largely due to the lobbying of landed gentry, who feared a census would lead to higher taxes on property owners. However, the revolutions in America (1777) and France (1789) stirred new fears among Britain’s elite of potential uprising by their own servants and labourers. Other fears were generated by contemporary wars. As America and France had taken censuses of their populations and thus had greater knowledge of their people, British politicians feared this might give the enemy an advantage. Other socio-political thinkers had a more philanthropic motive for wanting a census. They wanted to know more about the increasing urban poor: where and how they lived, how many there were, where they came from and the nature of their work. The resulting knowledge was intended to be used to improve the lives of the poor."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a4",
      "id": "A4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the meantime, Potter’s efforts had influenced others, including members of the Royal Society and fellow MPs. Astatistician, John Rickman (1771–1840), who later served as a clerk in the House of Commons, wrote a memorandum in 1796 entitled ‘Thoughts on the Utility and Facility of a General Enumeration of the People of the British Empire.’ This was brought to the attention of MP and Royal Society Fellow Charles Abbot (1757–1829, later 1st Baron Colchester), by George Rose, MP (who later introduced Rose’s Act of 1812). With Abbot’s support, Rickman’s ideas had a great effect on Parliament and led a few years later to the ‘Act for taking Account of the Population of Great Britain, and of the Increase in Diminution thereof’ of 1800.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Commonly referred to as the Census (Population) Act of 1800, this established a regular national census, which would be taken every ten"), _c('a', {
    attrs: {
      "id": "VPS-16"
    }
  }, [_vm._v(" years from 1801. The resulting census data from 1801, 1811, 1821 and 1831 is stored at The National Archives (TNA) in Kew. The reports are entitled ‘Abstracts of the Answers and Returns made pursuant to an Act for taking account of the Population of Great Britain, and of the increase or diminution thereof.’")])]), _c('a', {
    attrs: {
      "id": "VPS-16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The new census was overseen by John Rickman, whom Abbot appointed as his private secretary in 1800. Rickman would be rewarded for his work when he was appointed a Fellow of the Royal Society in 1815. He was recognized not just in Britain, but also in Europe, where he received a diploma as honorary membership of the Société Française de Statistique Universelle in 1833.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-16"
    }
  }, [_vm._v("In his memorandum, Rickman wrote: ‘It will be intuitively granted that an intimate knowledge of a country can be the only foundation of the legislation of that country, and also of its political relation to other nations.’"), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a5",
      "id": "A5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" The population census gave the government information on societal patterns, which would be useful for military recruitment during the contemporary war with France. The 1801 census is, however, of limited use to family historians as it consists of statistics of households but contains few names.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead",
    attrs: {
      "id": "h3a3"
    }
  }, [_vm._v("The Historical Use of Censuses")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On Tuesday, 10 March 1801 in England, Scotland and Wales, the first national census of Britain was taken. This census did not cover the Channel Islands, the Isle of Man or Ireland. The overseers of the poor for each parish (or township, tithing or quarter) were asked to collect certain information on their respective parishes. If they knew the details, they were not required to ask their parishioners. With this information, they filled in the schedule returns which were then sent to the Secretary of State for the Home Office."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a6",
      "id": "A6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "ch1"
  }, [_c('span', {
    staticClass: "chhang"
  }, [_vm._v("•")]), _vm._v(" HOUSES")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_vm._v("Inhabited")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_vm._v("By how many Families occupied")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_vm._v("Un-inhabited")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_c('span', {
    staticClass: "chhang"
  }, [_vm._v("•")]), _vm._v(" PERSONS")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_vm._v("Males")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_vm._v("Females")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_c('span', {
    staticClass: "chhang"
  }, [_vm._v("•")]), _vm._v(" OCCUPATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_vm._v("Persons chiefly employed in Agriculture")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_vm._v("Persons chiefly employed in Trade, Manufactures, or Handicraft")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_c('span', {
    staticClass: "chhang"
  }, [_vm._v("•")]), _vm._v(" TOTAL OF PERSONS")]), _vm._v(" "), _c('p', {
    staticClass: "ch1"
  }, [_vm._v("All other Persons not comprised in the Two Preceding Classes.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-17"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This census did not ask for ages, which limited its usefulness in providing statistics of potential military recruits. It also neglected men serving in the armed forces and militia, as well as merchant seamen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1811, questions were similar, but not identical, to those of 1801. The occupation questions asked for the number of families engaged in trade, agriculture and so on. One purpose of this was to monitor dwindling numbers of those engaged in family-based labour. Results would show how the population was moving away from family-based jobs into industrial roles in the ever-expanding towns and cities. This census, which was taken on Monday, 27 May, also differentiated the number of uninhabited houses between those that were abandoned and those that were being built. Although the questions were answered by the overseers of English and Welsh parishes, in Scotland they were answered by local schoolmasters.")]), _vm._v(" "), _c('div', {
    staticClass: "block_"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Questions")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("1st.")]), _vm._v(" How many Inhabited Houses are there in your Parish, Township, or Place; and by how many Families are they occupied?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("2d.")]), _vm._v(" How many Houses are now building, and therefore not yet inhabited?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("3d.")]), _vm._v(" How many other Houses are uninhabited?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("4th.")]), _vm._v(" What Number of Families in your Parish, Township, or Place, are chiefly employed in and maintained by Agriculture; how many Families are chiefly employed in and maintained by Trade, Manufactures, or Handicraft; and how many Families are not comprised in either of the two preceding Classes?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("5th.")]), _vm._v(" How many Persons (including Children of whatever Age) are there actually found within the Limits of your Parish, Township, or Place, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("at the Time of taking this Account")]), _vm._v(", distinguishing Males and Females, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exclusive")]), _vm._v(" of Men actually serving in His Majesty’s Regular Forces, in the Old Militia, or in any "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Embodied")]), _vm._v(" Local Militia, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exclusive")]), _vm._v(" of Seamen either in His Majesty’s Service or belonging to Registered Vessels?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("6th.")]), _vm._v(" Referring to the number of Persons in 1801, To what Cause do you attribute any remarkable Difference in the number at present?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("7th.")]), _vm._v(" Are there any other Matters, which you may think it necessary to remark, in Explanation of your Answers to any of the preceding Questions?")])])]), _c('a', {
    attrs: {
      "id": "VPS-18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Results of the censuses could, from this point on, be found in local newspapers. Care should be taken with this, however, as some of these published results were unofficial and thus unreliable. These can be accessed at the relevant local archives or (depending on title) online at the British Newspaper Archive:")])]), _c('div', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "VPS-18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first attempt to take an Official Census in this country was made in 1813, pursuant to an Act passed in 1812. Under this statute the supervision of the enumeration was entrusted to the Grand Juries of the several counties. This arrangement worked badly, the Grand Juries, from their constitution, not being capable of efficiently superintending the work, and having at their disposal no adequate machinery for its accomplishment…[A]fter two years spent in a fruitless endeavour…the attempt was abandoned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The failure of this inquiry directed public attention to the necessity of providing more effective machinery, and an Act was passed in 1815 vesting the superintendence of the next census in the Magistrates at Quarter Sessions and the Assistant Barristers; and accordingly the Census of 1821 was taken under their supervision. Though there was no staff officially under the control of the magistrates, yet the nomination of the enumerators was placed in their hands, and much care appears to have been taken to secure the services of men who were competent to perform the duty. At first many difficulties appeared. In some districts open hostility manifested itself, while in others the undefined state of the boundaries caused many obstacles to the compilation of a satisfactory statistical return. These, however, having been surmounted, the results of the first authoritative and complete Irish Census were presented to the public in 1823.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A second enumeration of the people was taken in 1831. The inquiry, however, was not commenced simultaneously in all parts of the country, and it extended over a considerable period. The Enumerators, moreover, were under the impression that they would be paid in proportion to the numbers they enumerated, a system of payment which, it appears, was in many cases actually adopted. For these and other reasons, the results of this Census have not been regarded as satisfactory.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-18"
    }
  }, [_vm._v("The Census of 1841 opened a new era in Irish Statistics. It was then for the first time that the Ordnance Survey maps were available, and a regularly organized police force – the Constabulary – at hand, from which a corps of Enumerators could be selected. The Commissioners of 1841 were also the first to employ Forms of Family Return, to be")]), _c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }, [_vm._v(" filled by the Head of the Family instead of having the particulars entered by the Enumerator from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("viva voce")]), _vm._v(" inquiry. Their report deals with the population viewed in most of its social aspects, and it has rightly been regarded as a model of succinctness.")])]), _c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Census of 1851 was taken under the superintendence of the Registrar-General of Marriages, Mr. William Donnelly, assisted by Dr. (afterwards Sir) William Wilde. The chief features of that enumeration were the School Census and the Report on the Status of Disease, which, in addition to treating of the number of people suffering from sickness, dealt with the deaf and dumb, the blind, the lunatic and idiotic, and the lame and decrepit. An interesting Table of Cosmical Phenomena, Epizootics, Famines and Pestilences in Ireland, from the earliest records published, was also compiled by the Assistant Commissioner, aided by the eminent Irish scholars, Dr. O’Donovan and Mr. Eugene O’Curry, MRIA. The Agricultural Statistics (first commenced in 1847) for 1851 and 1852 were collected by the Commissioners, who also published detailed statistics of emigration.")])])]), _c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }, [_vm._v("The first national census of Ireland was taken between 1813 and 1815."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a7",
      "id": "A7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" This was legislated by the Census (Ireland) Act of 1812 (52 Geo. III c.133), which appears to have been based on the British census of 1811. The Irish census was conducted by mainly Protestant parish officers and barony constables. This led to conflict with the many Catholic householders, some of whom refused to co-operate. Consequently, the census produced few results, but an abstract was published in 1822 and can be viewed on the Online Historical Populations Report (HISTPOP)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a8",
      "id": "A8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1821 census was taken on Monday, 28 May. Ireland was for the first time included in the census-taking. However, it was enumerated and reported separately from those of the English, Welsh and Scottish censuses. The Isle of Man and the Channel Islands were also enumerated for the first time this year. The questions on this occasion divided the population by age groups (left to the discretion of overseers). One of the purposes of this was to discover rates of life expectancy, the details of which would be used by insurance companies. Disappointingly for the said companies, the results of this census were never fully completed.")]), _vm._v(" "), _c('div', {
    staticClass: "block_"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Questions")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("1st.")]), _vm._v(" How many Inhabited Houses are there in your Parish, Township, or Place; and by how many Families are they occupied?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("2d.")]), _vm._v(" How many Houses are now building, and therefore not yet inhabited?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-20"
    }
  }, [_c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("3d.")]), _vm._v(" How many other Houses are Inhabited?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("4th.")]), _vm._v(" What Number of Families in your Parish, Township, or Place, are chiefly employed in and maintained by Agriculture, or by Trade, manufacture, or Handicraft; and how many Families are not comprised in either of the Two preceding Classes?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("5th.")]), _vm._v(" How many Persons (including Children of whatever Age) are there actually found within the Limits of your Parish, Township, or place, at the Time of taking this Account, distinguishing Males and Females, and exclusive of Men actually serving in His Majesty’s Regular Forces, in the Old Militia, or in any embodied Local Militia, and exclusive of Seamen either in His Majesty’s Service, or belonging to Registered Vessels?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("6th.")]), _vm._v(" Referring to the Number of Persons in one thousand eight hundred and eleven, To what Cause do you attribute any remarkable Difference in the Number at present?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("7th.")]), _vm._v(" If you are of Opinion that in making the preceding Enquiries (or at any Time before returning this Schedule,) the Ages of the several Individuals can be obtained in a Manner satisfactory to yourself, and not inconvenient to the Parties, be pleased to state (or cause to be stated) the Number of those who are under 5 Years of Age, of those between 5 and 10 Years of Age, between 10 and 15, between 15 and 20, between 20 and 30, between 30 and 40, between 40 and 50, between 50 and 60, between 60 and 70, between 70 and 80, between 80 and 90, between 90 and 100, and upwards of 100, distinguishing Males from Females – And are there any other Matters which you may think it necessary to remark in Explanation of your Answer to this or any of the preceding Questions – And in what Manner and to what Place of Residence and Post Office Town are Letters intended for you usually directed?")])])]), _c('a', {
    attrs: {
      "id": "VPS-20"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The census of Monday, 30 May 1831 was to be the last census overseen by John Rickman. Although similar in design to the previous censuses, the 1831 census would differ by extending the age columns by asking males whether they were above or below the age of 20. This information would be used for assessing the military potential of the population. However, there was no question that would help the politicians to learn about the ages or mortality levels of women and children. In order to further assess industrial growth, the census asked about occupational details for males aged over 20. Again, the large section of the working population that consisted of women and children was completely ignored.")])]), _c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }), _c('div', {
    staticClass: "block_"
  }, [_c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Questions")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("1st.")]), _vm._v(" How many Inhabited Houses are there in your Parish, Township, or Place; and by how many Families are they occupied?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("2d.")]), _vm._v(" How many Houses are now building, and therefore not yet inhabited?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("3d.")]), _vm._v(" How many other Houses are uninhabited?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("4th.")]), _vm._v(" What Number of Families in your Parish, Township, or Place, are chiefly employed in and maintained by Agriculture; or by Trade, Manufacture, or Handicraft; and how many Families are not comprised in either of the Two preceding Classes?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("5th.")]), _vm._v(" How many Persons (including Children of whatever Age) are there actually found within the Limits of your Parish, Township, or place, at the Time of taking this Account, distinguishing Males and Females, and exclusive of Men actually serving in His Majesty’s Regular Forces, in the Old Militia, or in any embodied Local Militia, and exclusive of Seamen either in His Majesty’s Service, or belonging to Registered Vessels?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("6th.")]), _vm._v(" How many of the Males enumerated in answer to the 5th Question are upwards of Twenty Years old?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("7th.")]), _vm._v(" How many Males upwards of Twenty Years old are employed in Agriculture, including Graziers, Cowkeepers, Shepherds, and other Farm Servants, Gardeners (not taxed or taxable as Male Servants), and Nurserymen?")])]), _c('p', {
    staticClass: "ch1a"
  }, [_c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("8th.")]), _vm._v(" How many Males upwards of Twenty Years old are employed in Manufacture or in making Manufacturing Machinery; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but not including Labourers in Warehouses, ")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/024_Glossary#gloss28",
      "id": "Gloss28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Porters")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/024_Glossary#gloss22",
      "id": "Gloss22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Messengers")]), _vm._v(", &c.; who are to be included in a subsequent Class?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("9th.")]), _vm._v(" How many Males upwards of Twenty Years old are employed in Retail trade or in Handicraft; as Masters, Shopmen, Journeymen, Apprentices, or in any Capacity requiring Skill in the Business; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but not including "), _c('span', {
    attrs: {
      "href": "#/xhtml/024_Glossary#gloss16",
      "id": "Gloss16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Labourers")]), _vm._v(", Porters, Messengers, &c. who are to be included in a subsequent Class")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("10th.")]), _vm._v(" How many males upwards of Twenty Years old are "), _c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#stara1",
      "id": "starA1"
    }
  }, [_vm._v("*")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wholesale")]), _vm._v(" Merchants, Bankers, Capitalists, Professional Persons, Artists, Architects, teachers, Clerks, Surveyors, and other Educated Men? And in answering this Question, you will include generally Persons maintaining themselves otherwise than by Manufacture, Trade, or bodily Labour.")]), _vm._v(" "), _c('p', {
    staticClass: "ch1at"
  }, [_vm._v("["), _c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1#starA1",
      "id": "stara1"
    }
  }, [_vm._v("*")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Retailer")]), _vm._v(" sells to the Consumer the Article sold.]")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }, [_c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("11th.")]), _vm._v(" How many males upwards of Twenty Years old are Miners, Fishermen, Boatmen, Excavators of Canals, Roadmakers, Toll Collectors, or Labourers employed by Persons of the Three preceding Classes, [Questions 8th, 9th, 10th,] or otherwise employed in any Kind of bodily Labour, excepting "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in Agriculture")]), _vm._v("? Labourer in Agriculture having been already entered in the proper Place.")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("12th.")]), _vm._v(" How many other Males upwards of Twenty Years old (not being taxable Servants under the next Question) have not been included in any of the foregoing Classes? Including, therefore, in answer to this Question, retired Tradesmen, Superannuated Labourers, and Males diseased or disabled in Body or Mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("13th.")]), _vm._v(" How many Household Servants, including all Female Servants, and such Male Servants (of whatever Age) as are taxed or taxable as such; also Waiters and Attendants at Inns; distinguishing the Males upwards of Twenty Years of Age from the Males under Twenty Years of Age?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("14th.")]), _vm._v(" If you have entered any Males in answer to the 8th Question, be please to specify Manufacture or Manufactures in which they are employed; and what Proportion of the Number of those entered in answer to Question 11th are employed in any Quarry, Mines, Coal Pits, Fishery, or public Work now in progress?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("15th.")]), _vm._v(" Referring to the number of Persons in the year 1821, to what cause do you attribute any remarkable difference in the number at present?")]), _vm._v(" "), _c('p', {
    staticClass: "ch1a"
  }, [_c('span', {
    staticClass: "chhanga"
  }, [_vm._v("16th.")]), _vm._v(" Are there any other matters which you may think it necessary to remark in explanation of your answers to any of the preceding Questions?")])])]), _c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }, [_vm._v("By the time of the 1841 census, John Rickman had died and a new monarch was on the throne. During the 1820s and 1830s, criticisms had been raised that Britain’s statistical system was too simplistic. The political economist J.R. McCulloch accused it of being ‘discreditable to the nation’. On 15 March 1834, the Statistical Society of London"), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a9",
      "id": "A9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" was formed by a group that included its first president, the statesman Henry Petty-Fitzmaurice, 3rd Marquess of Landsdowne, the mathematician, Charles Babbage, and the population theorist, Reverend Thomas Malthus. Scotland quickly followed, with the Statistical Society of Glasgow (1836) and, later, the Edinburgh Medico-Statistical Association (1852).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Philosophers and statisticians were now agreed that a different approach was required, and that the system of the census needed to be altered radically. In 1840, a committee of men from the London Statistical Society (LSS) made suggestions to be implemented in the census of the following year. Among its more successful suggestions was that of naming individuals and noting their details on household schedules, using enumerator transcripts to collate each household’s details, and of tabulating all the data in one place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From 1841 onwards, statisticians and politicians were able to use the census data for further purposes, notably to trace mortality and morbidity over time. This would later influence developments in town planning, public sanitation and housing. Particularly active in the use of census data for public health were the medical statistician Dr William Farr, the founder of epidemiology John Snow and the nursing pioneer Florence Nightingale. The population statistics were combined with date of birth, marriage and death records, schools and poor law boards to plan and influence government policy and social reform. Census reports were used well into the twentieth century to provide evidence to support changes to housing policy, such as with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Survey of London Life and Labour")]), _vm._v(" in 1930.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead",
    attrs: {
      "id": "h3a4"
    }
  }, [_vm._v("Current Uses of Historical Censuses")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the twenty-first century, historical censuses are accessed a great deal. Academics, statisticians, social theorists, economists, demographers, policy reformers and others continue to use censuses in much the way that they were intended by John Rickman, such as monitoring population levels. Historians can also use the census material in this way, but newer ways of looking at and learning from the census have emerged from the twentieth century. These include local, socio-economic and house history, as well as genealogy. Recent assessments of the censuses have considered changes in religious adherence, mortality rates and looked at changes in immigration and emigration over extended periods of time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since the 1960s, family historians have been inspired to use these censuses for their research. This is in many ways due to the work of D.J. (Don) Steel (1935–2008) and his Berkshire listings in ‘Earlier Censuses – Parish Censuses’ in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The National Index of Parish Registers")]), _vm._v(", vol. 1, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sources of Births, Marriages and Deaths before 1837")]), _vm._v(", part I, pp.333–6 (Society of Genealogists, 1968). Steel was active at the time in the area of one-name studies. From there, the work of Colin Chapman, Mervyn Medlycott and Jeremy Gibson has brought awareness of the use of censuses to a wider genealogy audience.")])]), _c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the 1970s and 1980s, genealogists travelled to the Land Registry in Portugal Street, London to examine the censuses of 1841–71 on microfilm. From here, the microfilms were moved to the Public Record Office (PRO) in London’s Chancery Lane. In 1997, copies of these microfilms were made available to family historians who used the newly opened Family Records Centre in Clerkenwell. That closed in 2008, after census usage had been transferred, for the most part, to online resources. Today, family historians can access censuses using a variety of online databases. This has enabled new ways of searching for, and examining, census material.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Microfilm or microfiche copies of the 1841–1901 census returns are available at most local record offices and Church of Jesus Christ of Latter-Day Saints’ (LDS) family history centres. Many libraries in the UK offer free access on site, or via a library card, to library editions of subscription sites, such as Ancestry and/or Findmypast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are a number of commercial and free census data providers online:")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancestry")])])]), _c('p', {
    staticClass: "head1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Ancestry.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Coverage: Indexes and images of census records from England, Wales, the Channel Islands and the Isle of Man, covering 1841–1911. Scottish census indexes and transcriptions for 1841–1901 inclusive. Free index for the 1881 census of England, Wales and the Islands in the British Seas, and for the UK census free sample. 1939 England and Wales Register.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: General and flexible search range. Can also search on the specific census.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Estimate ages to within 1, 2, 5 or 10 years. Search option of forename only. Wildcard search using ‘*’ after first or before last character and beside three non-wildcard letters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Census details and image can be saved to the online Ancestry family tree. The quality of the transcriptions varies, with 1881 being reported by users as the most accurate. Criticism of the Scottish transcriptions; praise for the source referencing of Scottish censuses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many genealogists say Ancestry is very easy to search from either the home page of the website, or the specific census or census year pages. Genealogists have praised its useful and accurate list of results, as well as its inclusion of birthplace in the search results. On a practical level, users like the zoom option, magnifier print and saving options.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, critics complain of a poor layout and that too many unrelated results are returned; there are a high number of transcription errors, and it can be hard to find an ancestor in the general search if any"), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }, [_vm._v(" transcription errors have occurred. Browsing by place is problematic, and changes in place names over time can be difficult to search. Spelling is not corrected but alternatives are provided. Scottish transcriptions are limited, with no recording of language spoken or infirmities, but are respected for their accuracy.")])]), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }, [_c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TheGenealogist")])])]), _c('p', {
    staticClass: "head1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }, [_c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "http://TheGenealogist.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("TheGenealogist.co.uk")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Coverage: Census transcriptions and images for 1841–1911. Set up as S&N Genealogy. The company also produces software and data products.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("Features: TheGenealogist master search allows for general and flexible searching by name of person, family or address (house & street). Includes an option of searching by keyword, such as an occupation, name or place. Gives the street address in the results. Other options (basic and advanced) to search individual censuses by year and county. Crew lists of 1861, 1871 and 1901. Also offers 1821 and 1831 censuses for London (Marylebone), and a 1921 census substitute (taken from various sources). Many genealogists like the simple layout, but are confused by the subscription options. TheGenealogist has volunteer census indexes; subscription-holders can access these without using any of their search credits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some images are clearer than on other sites.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Findmypast")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Findmypast.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Findmypast.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Coverage: Original images and (the company claims) ‘the most full and accurate transcriptions online’ for England, Wales, the Isle of Man and the Channel Islands 1841–1911 censuses. Indexes and transcriptions for Scottish censuses 1841–1901. Free indexes and basic transcriptions. Free fuller transcription for 1881. Subscriptions for image viewing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Offers a search of censuses via a general database option, or by specific census year. Offers a person search, an address search and a census reference search.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Advanced searches are also available. Genealogists have praised the simple layout of the search and results pages, especially the use of full addresses. They find the search options easy to use. They also highlight the ability to search name variables, locating members of the armed forces who are serving overseas, and to search on more than one named person in a house at once. There is praise for the address and occupation searches as well as the accuracy of the transcriptions, particularly of those in Scotland. Errors in transcriptions are fixed when reported.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Critics argue that the results are haphazard and that the referencing for Scottish censuses is poor. Transcriptions are incomplete.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Genes Reunited")])])]), _c('p', {
    staticClass: "head1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-26"
    }
  }, [_c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "http://www.genesreunited.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.genesreunited.co.uk")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: This covers indexes, transcriptions and images for 1841–1911. Also includes Scottish census transcriptions for 1841–1901, Corfe Castle and District 1790 Census, and Nether Hallam, Sheffield 1831 Census.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Offers subscription and pay-per-view searches. Details can be saved to the online family tree.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("FamilySearch")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.familysearch.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.familysearch.org")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: Incomplete indexes and basic transcriptions are available for the English and Welsh censuses of 1841–1911, and the Scottish 1841–91 censuses. Links to images provided (via subscription) by "), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Findmypast.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Findmypast.com")])])])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Free. Genealogists often use this site first to find a person or family, and then use that to consult the image on a commercial site. Searching by date of birth on this site can be successful. The accuracy of the transcriptions, particularly of 1881, is praised. There has been criticism of the new layout, which some find confusing.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("FreeCEN")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.freecen.org.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.freecen.org.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: Provides indexes and transcriptions to English, Scottish and Welsh censuses for 1841–91.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Free. Genealogists praise the quality of the transcriptions. Good coverage of Scottish censuses. Coverage is not comprehensive.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ScotlandsPeople")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.scotlandspeople.gov.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.scotlandspeople.gov.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: The only website to give full access to the images of the Scottish 1841–1911 censuses. Provides search indexes and transcriptions of 1841– 1911 censuses. Includes an 1881 LDS census search and transcription for free.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Search censuses by individual year. Wildcards can be used in the address search. When a census image is viewed, the header page (the enumerator’s description) can be viewed at no extra cost. Street indexes are available on the site. Critics complain of the paucity of search fields.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }, [_c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Scottish Indexes")])])]), _c('p', {
    staticClass: "head1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "weblink"
  })])]), _c('a', {
    attrs: {
      "href": "https://www.scottishindexes.com/recordsets.aspx",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://www.scottishindexes.com/recordsets.aspx")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: Free searches of the indexes to the 1841, 1851 and 1861 Scottish censuses, as well as pre-1841 censuses and population lists. The results of the searches link to free transcriptions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Offers searches by name, occupation, address/place, birth year and birthplace. Coverage for the 1841 census is limited to Berwickshire, Peeblesshire, Roxburghshire and Selkirkshire, with parts of Dumfriesshire, East Lothian and Midlothian. Coverage for 1851 is limited to Berwickshire, Dumfriesshire, Peeblesshire, Roxburghshire and Selkirkshire, as well as parts of East Lothian, Kirkcudbrightshire, Lanarkshire, Midlothian and Wigtownshire. The 1861 census covers Berwickshire, Peeblesshire, Roxburghshire and Selkirkshire, along with parts of Dumfriesshire, East Lothian and Midlothian.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Census of Ireland 1901/1911 and Census fragments and substitutes, 1821–51")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.census.nationalarchives.ie",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.census.nationalarchives.ie")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: Provides indexes, transcriptions and images of the household returns and ancillary records for the Irish censuses of 1901 and 1911.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1901 and 1911 censuses are the only complete surviving census records for the pre-Independence period. Fragments survive for 1821– 1851 for some counties, as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Antrim, 1851; Belfast city (one ward only), 1851; Cavan, 1821 and 1841; Cork, 1841; Dublin city (index to heads of household only), 1851; Fermanagh, 1821, 1841 and 1851; Galway, 1813 (numerical returns for Longford barony) and 1821; King’s County (Offaly), 1821; Londonderry (Derry), 1831–34; Meath, 1821; Waterford, 1841.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Free. The official Irish census website from The National Archives of Ireland. Search on all information categories: year, surname, forename, county, barony (except 1821), parish and townland/street. The 1841 and 1851 censuses usefully list members of the household not at home on census night, and also family members who died since 1831/1841.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Emerald Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.emeraldancestors.com/index.asp",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("http://www.emeraldancestors.com/index.asp")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: Northern Irish census records on a commercial website.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: The census records feature among the Ulster ancestry database. They include 1901 Fermanagh census, Northern Ireland census extracts 1841–51 and a nineteenth-century census collection.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }, [_c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RootsUK")])])]), _c('p', {
    staticClass: "head1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }, [_c('span', {
    staticClass: "weblink"
  })]), _c('a', {
    attrs: {
      "href": "http://www.rootsuk.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.rootsuk.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: Complete census images with transcripts. Data provided by TheGenealogist.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Similar options to TheGenealogist.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("UK Indexer")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.UKindexer.co.uk",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.UKindexer.co.uk")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: Volunteers who transcribe parish or other records receive free vouchers and subscriptions to TheGenealogist.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Features: Free access to some records for volunteer transcribers.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("UK Census Online")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ukcensusonline.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.ukcensusonline.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Coverage: Complete set of census records from England and Wales for 1841–1911, including transcripts and images of original documents.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Features: Searching the census is free but to view the full details and images a subscription must be bought. Saves money by paying only for censuses rather than the extra features of other databases.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("A full set of historical census reports is held by the British Library. These reports provide aggregate statistical information for each census question. The Library’s maps department holds detailed historical census maps which clarify the population differences in different parts of Britain and Ireland. The reports for 1921–91 are held on the open shelves in the Social Sciences Reading Room. Reports and other census material are also held at academic libraries. This can be identified via the COPAC internet search engine ("), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://copac.ac.uk/search",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("http://copac.ac.uk/search")])])])]), _vm._v("). Regional census reports should be found at local archives. The Vision of Britain website, in association with the Historical Geographic Information System (GIS) Project, based at the University of Portsmouth, contains census reports from 1801 to 1961 with direct access to the main tables.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All complete published census reports for England, Wales, Scotland and Ireland, 1801–1937 (bar the 1926 census of the Irish Free State) can be found at the Online Historical Populations Report (HISTPOP), "), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.histpop.org",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.histpop.org")])])])]), _vm._v(". These reports are not used generally for family history purposes, but can be useful for providing social and economic context. They are helpful for local historians and can be searched by place. In the ‘Legislation’ section of the website database are the full texts of all the Acts of Parliament relating to the census, dating back to 1801.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p29.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vision of Britain website.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are problems with interpreting the returns, and family historians should question the information given by their families to the enumerators; for example, regarding the nature of employment. In the Victorian period, part-time, seasonal and casual employment were common. The employment or unemployment of an ancestor on a census does not necessarily tell us what he or she was doing for the previous or next ten years, or even the next week. Working-class men may have had multiple occupations at once, but this is rarely recorded on the census. Feminist historians have long argued that women’s employment status has been misrepresented on the census, with thousands of women’s jobs simply ignored by the enumerator, particularly those who worked from home or with their husband.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }, [_vm._v("The terms used can also be problematic. Although ‘labourer’ and ‘scholar’ were defined for the enumerators (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/024_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")]), _vm._v("), these and other terms were often interpreted differently by individual householders and even some enumerators.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead",
    attrs: {
      "id": "h3a5"
    }
  }, [_vm._v("Why Some People Are Not Found on Censuses")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There can be a number of reasons why individuals cannot be found on censuses as expected. These include names being wrongly transcribed, incorrect spellings or being difficult to read. Sometimes people may simply not have been recorded on the census. In other cases, pieces of the censuses have been destroyed, damaged or are otherwise missing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where names have been wrongly transcribed, it is worth checking different indexes or websites produced by alternative transcribers."), _c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }, [_vm._v(" Besides the wrong appearance of a name, there is the possibility that an individual is enumerated under a different name from what was expected. This may be a formal name, nickname, middle name, shortened version of the name, or women recorded under their maiden name. Others may have the surname of their stepfather, mother’s common-law husband, a lodger or others above them in the household schedule (e.g. servants given the surname of their masters). Men may be found with the surname of a woman with whom they were cohabiting. Recent immigrants or others with a surname of foreign origin may have changed their name from the foreign spelling (e.g. Goodman instead of Gottman), or otherwise may be using an alias.")])]), _c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the early years particularly, ancestors may not be found as they were travellers, members of the armed forces, merchant seamen, or had gone abroad. Some individuals absented themselves from the census deliberately: they may have worried about being recorded for fear of tax, official knowledge of their whereabouts or to hide away from legal authorities or estranged spouses. Others, for example suffragettes in 1911, boycotted the census as a political protest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Parts of each census are either missing from The National Archives’ collection or no longer exist. In some cases, entries have faded or been destroyed. Specific details will be explored in the chapters on each census, but the census with the most missing sections is that of 1861. Some of these were destroyed by poor storage, while others were lost en route to the Registrar General in London.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }, [_vm._v("A few cases exist of individuals being arrested and even prosecuted for absenting themselves from the census."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/027_Endnotes#a10",
      "id": "A10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('h3', {
    staticClass: "subhead",
    attrs: {
      "id": "h3a6"
    }
  }, [_vm._v("Records of People in Institutions and the Homeless")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Identifying the correct person in the censuses of institutions, such as prisons, workhouses, hospitals or lunatic asylums, can be difficult. Often minimal details are included, such as inmates being recorded with initials only. The use of general geographic areas in the birthplace column (from 1851) – such as ‘London’ or ‘Scotland’ without mention of a parish or even the wrong parish completely – is common. This also occurs with records of the armed forces and boarding schools.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Homeless people who slept on the streets are not usually enumerated. Those who were sheltered in an institution, even if only for census night, however, should be recorded. Besides workhouses, there were asylums dedicated to those with no home. In Hackney, on the 1861 census these included the Refuge for the Destitute, Dalston. Located in St Giles Bloomsbury was the Refuge for Homeless and Destitute Girls. Homeless"), _c('a', {
    attrs: {
      "id": "VPS-31"
    }
  }, [_vm._v(" children may be found in orphanages, workhouses or industrial homes. Other homeless people who avoided asylums may be found enumerated with relatives or as lodgers.")])]), _c('a', {
    attrs: {
      "id": "VPS-31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Those whose work or lifestyle may have excluded them from one or more censuses are examined further in the chapters on the respective censuses from 1841 onwards.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55243bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/007_Chapter_1.vue
// module id = 75
// module chunks = 0